import { Component, Input } from '@angular/core';
import { StreappEvent } from '../../../../models/streappevent.model';
import { DomSanitizer } from '@angular/platform-browser';
import { StreApperInfo } from 'src/app/models/streapper-info.model';
import { extraSubscriberRoles } from 'src/app/constants/extraSubscriberRoles';
import { subscriberRoles } from 'src/app/constants/subscriberRoles';

@Component({
    selector: 'page-attributes',
    templateUrl: './page-attributes.component.html',
    styleUrls: ['./page-attributes.component.scss'],
    standalone: false
})
export class PageAttributesComponent {
  @Input() event: StreappEvent;
  subscriptionRoles: string[];

  private _streapper!: StreApperInfo;

  @Input()
  set streapper(value: StreApperInfo) {
    this._streapper = value;
    this.onStreapperChanged(value);
  }

  get streapper(): StreApperInfo {
    return this._streapper;
  }

  private onStreapperChanged(value: StreApperInfo) {
    this.filterSubscriptionRoles(value?.roles ?? []);
  }

  constructor(
    private domSanitizer: DomSanitizer
  ) {}

  filterSubscriptionRoles(roles: string[]) {
    var subRoles = roles.filter(r => new Set(subscriberRoles).has(r));

    // Fallback
    if(subRoles.length === 0) {
      subRoles = ["User"];
    }

    const extraRoles = roles.filter(r => new Set(extraSubscriberRoles).has(r));;

    this.subscriptionRoles = [...subRoles, ...extraRoles].slice(0, 3) ?? [] // 3 badge limit;
  }

  generateLink(): string {
    if (this.event.isReporter) {
      return '/streappers/detail';
    } else {
      return '/users/detail';
    }
  }

  getEventProfilePicture() {
    if (this.event.createdByImage) {
      if (this.event.createdByImage.startsWith('http')) {
        return this.event.createdByImage;
      }
      return this.domSanitizer.bypassSecurityTrustUrl(
        'data:image/*;base64,' + this.event.createdByImage
      );
    }
  }
}
